import { render } from "./OverlayMessage.vue?vue&type=template&id=2e965a75&scoped=true"
import script from "./OverlayMessage.vue?vue&type=script&lang=js"
export * from "./OverlayMessage.vue?vue&type=script&lang=js"

import "./OverlayMessage.vue?vue&type=style&index=0&id=2e965a75&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/fw-312-bird-identification-game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e965a75"]])

export default __exports__